import request from '../../utils/request';
import qs from 'qs'


export function getQwAndYuanNeiCustomer(param, Authorization){
  return request({
    //url: '/chaoren',
    url: '/api/qywechat/getQwAndYuanNeiCustomer',
    method: 'post',
    data: param,
    headers: {
      // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
      "authorization": Authorization
    }
  })
}

export function getChatQwAndYuanNeiCUstomer(param, Authorization){
  return request({
    //url: '/chaoren',
    url: '/api/qywechat/getChatQwAndYuanNeiCUstomer',
    method: 'post',
    data: param,
    headers: {
      // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
      "authorization": Authorization
    }
  })
}


export function synchWeCustomer(Authorization){
  return request({
    url: '/api/qywechat/synchWeCustomer',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}

export function getCustomerContactList(sendFrom,startTime,endTime,current,size,Authorization,isloading){
  return request({
    // url: '/api/qywechat/getQwCustomerContactList?'+ 'sendFrom=' + sendFrom + '&startTime=' + startTime + '&endTime=' + endTime + '&current=' +current+ '&size=' + size,
    url: '/api/qywechat/getQwCustomerContactList/'+ sendFrom + '/' +current+ '/' + size + '/' + startTime + '/' + endTime,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

export function getDialogInfo(sendFrom,sendTo,current,size,Authorization,isloading,msgType) {
  let url = '/api/qywechat/getQwCustomerDialog/'+sendFrom+'/'+sendTo+'/'+current+'/'+size
  if(msgType) {
    url = url + `?msgType=${msgType}`
  }
  return request({
    // url: '/api/qywechat/getQwCustomerDialog?'+'sendFrom='+sendFrom+'&sendTo='+sendTo+'&current='+current+'&size='+size,
    url,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 保存日志
export function saveLog(Authorization){
  return request({
    url: '/api/cusinfo/exportlog/create',
    method: 'post',
    headers: {
      "authorization": Authorization
    }
  })
}


/** 新版获取客户列表 */
export function getCustomerList(param, Authorization){
  return request({
    url: '/api/qywechat/getCustomerList ',
    method: 'post',
    data: param,
    headers: {
      "authorization": Authorization
    }
  })
}


/** 新版获取客户对应的员工列表 */
export function getCustomerStaffList(sendFrom,startTime,endTime,current,size,Authorization){
  return request({
    // url: '/api/qywechat/getCustomerStaffList/'+ sendFrom + '/' +current+ '/' + size + '/' + startTime + '/' + endTime,
    url:`/api/qywechat/getCustomerStaffList/${sendFrom}/${current}/${size}/${startTime}/${endTime}`,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },true)
}

/** 新版获取客户对应员工聊天内容 */
export function getCustomerChatMsg(sendFrom,sendTo,current,size,Authorization,msgType) {
  let url = `/api/qywechat/getCustomerChatMsg/${sendFrom}/${sendTo}/${current}/${size}`
  if(msgType) {
    url = url + `?msgType=${msgType}`
  }
  return request({
    url,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },true)
}
